export default {
  SAVE_INVOICE_DATA : "SAVE_INVOICE_DATA",
  GET_INVOICE_DATA: "GET_INVOICE_DATA",
  CLEAR_INVOICE_DATA:"CLEAR_INVOICE_DATA"
};
